import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { IState } from '../../../../store/types';
import { getGroups } from '../../../../store/models/selectors';
import { getAuthUser } from '../../../../store/general/selectors';
import { CallSelectors } from '../../../../store/call/selectors';
import { EUserGroupType } from '../../../../store/general/types';
import { IPastLessonsButtonEvents, IPastLessonsButtonFields } from '../components/types';
import { PastLessonsButtonEvents } from './events';
import { PastLessonsButton } from '../components/PastLessonsButton';

// memoized: a fresh filtered array on every store change would re-render the tray button each time
const getConferenceGroups = createSelector(
	getGroups,
	groups => groups.filter(g => g.type === EUserGroupType.CONFERENCE),
);

const mapStateToProps = (
	state: IState
): IPastLessonsButtonFields => ({
	groups: getConferenceGroups(state),
	roomId: CallSelectors.getRoomId(state),
	myId: getAuthUser(state)?.id || 0,
	isTeacher: !!getAuthUser(state)?.teacher,
});

const mapDispatchToProps = (
	dispatch: any
): IPastLessonsButtonEvents => ({
	onOpen: (groupId, audioId) => dispatch(PastLessonsButtonEvents.onOpen(groupId, audioId)),
});

export const PastLessonsButtonHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(PastLessonsButton);

PastLessonsButtonHOC.displayName = 'PastLessonsButtonHOC';
